module.exports = __webpack_public_path__ + "img/national-society-logo.4ad9ccfc.png";